import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { matchingFieldsValidator } from '../../shared/validators/matchingFields.validator';

import { Textbox } from './../../models/editors/textbox.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';

export const SUCCESS_MESSAGE = 'Heslo bylo úspěšně změněno!';
export const ERROR_MESSAGE = 'Změna hesla se nezdařila - zkuste zkontrolovat, zda jste správně zadali původní heslo.';
export const NOTALLOWED_MESSAGE = 'Změna hesla není povolena.';

@Component({
  selector: 'swb-password',
  templateUrl: './password.component.html',
  providers: [FormControlService]
})
export class PasswordComponent implements OnInit {
  public form: FormGroup;
  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'password',
        label: 'Současné heslo',
        type: 'password',
        validators: [Validators.required]
      }),
      new Textbox({
        key: 'new_password',
        label: 'Nové heslo',
        type: 'password',
        validators: [Validators.required]
      }),
      new Textbox({
        key: 'password_confirmation',
        label: 'Nové heslo znovu',
        type: 'password',
        validators: [Validators.required, matchingFieldsValidator('new_password')]
      })
    ];
  }
  public FormEditors: any;
  public isSaving = false;

  private _id: string;

  constructor(private _formService: FormControlService,
    private _apiService: ApiService,
    private _router: Router,
    private _alertService: AlertService) { }

  ngOnInit() {

    this._setupForm();

  }

  public save() {
    this.form.updateValueAndValidity();
    if (this.form.valid) {
      this.isSaving = true;
      this._apiService.post(this.form.value, 'users/password').subscribe(
        (response: any) => {
          if ({ ...response }.status <= 0) {
            this._alertService.error(ERROR_MESSAGE);
          } else if ({ ...response }.status === 2) {
            this._alertService.error(NOTALLOWED_MESSAGE);
          } else {
            this._router.navigate(['./dashboard']);
            this._alertService.success(SUCCESS_MESSAGE);
          }
          this.isSaving = false;
        },
        (error) => {
          this._alertService.error(ERROR_MESSAGE);
          this.isSaving = false;
        }
      );
    }
  }
  private _setupForm(): void {
    this.form = this._formService.toFormGroup(this.fieldsConfig.slice(), null);
    this.FormEditors = this._formService.toTemplateInput(this.fieldsConfig.slice(), null);

  }

}
